"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCorrectTimeLevel = void 0;
const types_js_1 = require("./types.js");
const getCorrectTimeLevel = (level, bucket) => {
    let newLevel = level ? level.toLocaleLowerCase() : types_js_1.DatetimeLevel.YEARS;
    if (newLevel === types_js_1.DatetimeLevel.MINUTES && bucket === '60') {
        newLevel = types_js_1.DatetimeLevel.HOURS;
    }
    return newLevel;
};
exports.getCorrectTimeLevel = getCorrectTimeLevel;
